<div class="box">
    <div class="buttonsTop">
        <button mat-button (click)="close()"><mat-icon>close</mat-icon></button>
    </div>
    <ul class="lista">
        <li>.222 Remington PSP 50 GR</li>
        <li>.223 Remington- Hornady 55 gr VMAX, Hornady 75 gr. BTHP</li>
        <li>.22-250 Rem.- Hornady 55 gr. VMAX, Nosler 64 gr. BSB, . Norma V-MAX 50 GR</li>
        <li>.243 Win.- Hornady 100 gr. Interlock, Geco Teilmantel 105gr.</li>
        <li>.270 win- Nosler 130 gr. Accubond, Geco Teilmantel 140gr</li>
        <li>7mm-08-Hornady 120 Gr. SST</li>
        <li>7mm RemMag-Norma 156 gr. Oryx, Hornady 162 gr. ELD-X, Geco Teilmantel 165gr</li>
        <li>.30-06- Barnes 168 gr. TSX, Hornady 178 Gr. ELD-X</li>
        <li>.300 BLK- Hornady 208 gr AMAX</li>
        <li>.300 Win Mag- Berger 185 gr Juggernaut, Norma 180 gr. Oryx-Bondstrike. Geco Teilmantel 170gr</li>
        <li>.308 win- 168 Federal Gold Medal Match, 175 gr. Federal Gold Medal Match, Berger 175 gr OTM, Geco Teilmantel 170gr</li>
        <li>6.5 Creedmoor- Hornady 140 gr. ELD Match, Hornady 143 Gr. ELD-X</li>
        <li>.44 mag-Hornady 300 gr. FTX</li>
        <li>.35 Whelen- Hornady 200 gr. Superformance</li>
        <li>6MM Creedmoor-Hornady 108 gr. ELD-Match</li>
        <li>280 AI- Nosler Trophy Grade 140 gr. Accubond</li>
        <li>.450 Bushmaster-Hornady 250 gr. FTX</li>
        <li>6.5 PRC – Hornady 147 gr. ELD-M</li>
        <li>300 PRC – Hornady 225 gr. ELD-M</li>
        <li>28 Nosler – Match Grade 28 Nosler 168 gr</li>
        <li>BXR .22 – CCI Standard, Blazer 40gr LRN, Federal Gold Medal Target, Eley Match OSP, Avoid bulk ammo with coated projectiles</li>
        <li>B-14R .22 LR/BMR .22 LR – Eley Tennex, Eley Match, Federal Gold Medal Ultra Match, Lapua Center X, RWS R50-R100</li>
        <li>B-14R .22 WMR/BMR .22 WMR – CCI 40gr</li>
        <li>B-14R .17 HMR/BMR .17 HMR – Federal Premium 17gr Hornady Vmax</li>
      </ul>
      
</div>